
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/omtaler",
      function () {
        return require("private-next-pages/[region]/[resort]/omtaler.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/omtaler"])
      });
    }
  